import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

function assertValidToken(token) {
  if (typeof token !== "string" || token.trim().length < 10) {
    throw new Error(
      "Token inválido (frontend): revisa AuthContext/accessToken",
    );
  }
}

export class PatientReviApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.routes = ENV.API_ROUTES;
  }

  async getByInstitution(token, institutionId, { page = 1, limit = 10 } = {}) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/get/${institutionId}?page=${page}&limit=${limit}`;
    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json;
  }

  async getMyForTherapist(
    token,
    { page = 1, limit = 12, search = "", sexo } = {},
  ) {
    assertValidToken(token);

    const query = new URLSearchParams({ page, limit });
    if (search) query.set("search", search);
    if (sexo) query.set("sexo", sexo);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/therapist/me?${query.toString()}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json;
  }

  // Perfil (Paciente + User)
  async getProfile(token, patientId) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI_PROFILE}/get/${patientId}`;

    const response = await fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) {
      throw new Error(
        json.message || "Error al obtener el perfil del paciente",
      );
    }
    return json; // idealmente { patient, user }
  }

  // ✅ Alias para no liarnos (igual que terapeutas)
  async getById(token, patientId) {
    const json = await this.getProfile(token, patientId);
    return {
      patient: json.patient ?? json,
      user: json.user ?? null,
    };
  }

  async create(token, institutionId, data) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/create/${institutionId}`;

    const response = await fetch(url, {
      method: "POST",
      headers: cabecerasApi(token),
      body: data,
    });

    const json = await response.json();
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(json.message);
    }
    return json;
  }

  async update(token, patientId, data) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/${patientId}`;

    const response = await fetch(url, {
      method: "PATCH",
      headers: cabecerasApi(token),
      body: data,
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json;
  }

  async updateClinicalInfo(token, patientId, data) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/${patientId}/clinical-info`;

    const response = await fetch(url, {
      method: "PATCH",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json;
  }

  async delete(token, patientId) {
    assertValidToken(token);

    const url = `${this.baseApi}/${this.routes.PATIENT_REVI}/${patientId}`;

    const response = await fetch(url, {
      method: "DELETE",
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200) throw new Error(json.message);
    return json;
  }
}
